import {
  mediaQueryStyles,
  constants,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { textMObj } = typographyStyles;

export const modalCss = {
  root: {
    zIndex: 15,
  },
  modalContentWrapper: {
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      maxWidth: 750,
      height: "fit-content",
    },
  },
  scrollableBody: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 30,
    p: {
      ...textMObj,
      margin: 0,
    },
    ul: {
      margin: 0,
      paddingLeft: 25,
      "li:not(:first-of-type)": {
        marginTop: 10,
      },
    },
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    button: {
      [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
        width: "100%",
      },
    },
  },
};
